import { Injectable } from '@angular/core';
import { PreferenceStorageService } from '@app/shared/services/preference-storage.service';
import { toggleClass } from '@app/utils/toggle-class';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MainNavService {
  private storageKey = 'mainNav.expanded';

  private toggleAndSave = (expanded: boolean): void => {
    this.toggleClass(expanded);
    this.preferenceStorageService.updatePreference(this.storageKey, expanded);
  };

  constructor(private preferenceStorageService: PreferenceStorageService) {
    this.preferenceStorageService.preference$<boolean>(this.storageKey, false).subscribe((expanded) => {
      this.toggleClass(expanded);
    });
  }

  toggleMainNav(expanded?: boolean): void {
    if (expanded != null) {
      this.toggleAndSave(expanded);
    } else {
      this.preferenceStorageService
        .preference$(this.storageKey)
        .pipe(
          take(1),
          map((expanded) => !expanded)
        )
        .subscribe(this.toggleAndSave);
    }
  }

  private toggleClass(expanded: boolean): void {
    toggleClass('main-nav-expanded', document.body, expanded);
  }
}
